<template>
  <v-combobox
    v-model="seleccionado"
    :items="datos"
    :loading="isLoading"
    :label="label"
    item-text="text"
    return-object
    hide-details
    outlined
    dense
    clearable
    @change="emitir"
  />
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'SeleccionarUsuario',
  props: {
    value: { type: Object, default: null },
    label: { type: String, default: 'Seleccione usuario' },
    preselectId: { type: Number, default: null },
    preselectNombre: { type: String, default: null },
  },
  data() {
    return {
      datos: [],
      isLoading: false,
      seleccionado: null,
    };
  },
  watch: {
    preselectId() {
      this.intentarPreselect();
    },
    preselectNombre(val) {
      // Mostrar nombre inmediatamente si aún no se ha cargado la lista
      if (val && !this.seleccionado) {
        this.seleccionado = { id: this.preselectId, nombres: val, text: val };
      }
    },
  },
  methods: {
    emitir() {
      this.$emit('input', this.seleccionado || null);
    },
    intentarPreselect() {
      const id = this.preselectId;
      if (!id) return;
      if (this.datos.length) {
        const found = this.datos.find(x => x.id == id);
        if (found) {
          this.seleccionado = found;
          this.$emit('input', found);
          return;
        }
      }
      // Si la lista aún no cargó, mostrar nombre si está disponible
      if (this.preselectNombre) {
        this.seleccionado = { id, nombres: this.preselectNombre, text: this.preselectNombre };
      }
    },
    async getDatos() {
      this.isLoading = true;
      const idsede = this.$store.state.CARGO.idsede;
      const sql = gql`query{ getSede(id:${idsede}){ usuarios_activos{ usuario{ estado, datos_personales{ id, nombres, pri_apellido, seg_apellido } } } } }`;
      const data = await this.$apollo.query({ query: sql }).then(d => d).catch(() => null);
      this.isLoading = false;
      if (!data || !data.data || !data.data.getSede) return;
      const activos = data.data.getSede.usuarios_activos || [];
      this.datos = activos
        .filter(e => e.usuario.estado)
        .map(e => {
          const dp = e.usuario.datos_personales;
          const seg = dp.seg_apellido || '';
          const nombre = `${dp.nombres} ${dp.pri_apellido} ${seg}`.trim();
          return { id: dp.id, nombres: nombre, text: `${nombre} (${dp.id})` };
        });
      // Intentar preselección ahora que la lista está cargada
      if (this.preselectId) this.intentarPreselect();
    },
  },
  created() {
    // Mostrar nombre inmediatamente si ya se pasó antes de que cargue la lista
    if (this.preselectId && this.preselectNombre) {
      this.seleccionado = { id: this.preselectId, nombres: this.preselectNombre, text: this.preselectNombre };
    }
  },
  mounted() {
    if (this.$store.state.CARGO) this.getDatos();
  },
};
</script>
